<template>
    <div class="home-page">
        <!-- 新闻资讯 -->
        <div class="news">
            <div class="main-news-list flex-layout">
                <div class="news-swiper-container">
                    <el-carousel class="swiper-news" arrow="hover" ref='carousel' :autoplay="false" @change="changeNews">
                        <el-carousel-item v-for="(item, index) in newsList" :key="index" class="item">
                            <img :src="item.cover" alt="" class="news-img csp" @click="goDetail(item)">
                        </el-carousel-item>
                    </el-carousel>
                </div>
                <div class="news-part">
                    <div class="tab-wrap">
                        <div class="flex-layout inner-tab" style="width:100%;">
                            <div class="menu-box" :class="activeIndex == menuIndex ? 'tabActive' : ' '"
                                @click="chooseMenu(menuIndex)" v-for="(menu, menuIndex) in menuList" :key="menuIndex">
                                {{ menu.label }}
                            </div>
                            <span class="bottom_line" :style="`left:${left}px`"></span>
                        </div>
                    </div>
                    <div class="part-contaner csp" @click="goDetail(currenBannerNews)">
                        <h5 class="news-part-title wes-2">{{ currenBannerNews ? currenBannerNews.title : '' }}
                        </h5>
                        <p class="news-part-desc wes-4">
                            {{ currenBannerNews ? currenBannerNews.introduction : '' }}</p>
                        <p class="news-part-info">
                            <span class="news-part-time">{{ currenBannerNews ?
                                dayjs(currenBannerNews.createTime).format('YYYY-MM-DD') : '--' }}</span>
                            <span class="news-part-label csp" @click.stop="goNewsList(menuList[activeIndex])">#{{
                                menuList[activeIndex].label }}</span>
                        </p>
                    </div>
                </div>
            </div>
            <ul class="other-news-list flex-layout">
                <li v-for="(item, index) in otherNewsList" :key="index" class="other-news-item"
                    @click="goDetail(item, clazz)">
                    <img :src="item.cover" alt="" class="other-news-img">
                    <div class="other-news-info">
                        <p class="other-news-desc wes-2">{{ item.title }}</p>
                        <div class="other-news-time flex-align-between">
                            <span class="news-source">{{ menuList[activeIndex].label }}</span>
                            <span class="news-time">{{ item.updateTime }}</span>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
        <!-- 核心价值 -->
        <div class="sanyi">
            <div class="title">协作模式</div>
            <img src="../assets/new/san.png" alt="">
        </div>

        <!-- 课程表 -->
        <div class="rili">
            <div class="title">课程表</div>
            <Calendar @goCourse="goCourse"></Calendar>
        </div>
        <!-- 优质课程 -->
        <div class="course">
            <div class="title">优质课程</div>
            <div class="course_list">
                <div class="course_item" v-for="(item, index) in courseList" :key="index" @click="goCourse(item.id)">
                    <img :src="imgUrl + item.cover" :onerror="$store.state.course.defaultCourseCover[index % 5]">
                    <div class="course_title">{{ item.name }}</div>
                    <div class="description">{{ item.courseExplain }}</div>
                </div>
            </div>
            <div class="course_more flex-align-center">
                <div class="more" @click="gocurriculumPublic">更多</div>
            </div>
        </div>
        <!-- 协作学校 -->
        <div class="school">
            <div class="title">协作学校</div>
            <div class="school_box">
                <div class="school_item flex-column-center" v-for="(item, index) in schoolList" :key="index">
                    <img :src="item.img" alt="">
                    <span class="schoolName wes">{{ item.name }}</span>
                </div>
            </div>
        </div>
        <!-- 媒体关注 -->
        <div class="attention">
            <h3 class="attention-title">媒体关注</h3>
            <ul class="attention-list">
                <li class="attention-item csp" v-for="(item, index) in focusList" :key="index" @click="goDetail(item)">
                    <div class="cover-wrapper">
                        <img :src="item.cover" alt="" class="cover">
                        <h4 class="item-title">{{ item.title }}</h4>
                    </div>
                    <div class="report-info">
                        <p class="desc wes-2">{{ item.introduction }}</p>
                        <div class="flex-align-between ">
                            <img :src="item.userCover" alt="" class="report-source">
                            <span class="report-time">{{ item.createTime }}</span>
                        </div>
                    </div>
                </li>
            </ul>
            <div class="csp click-all">
                <button class="click-all-btn csp" @click="goAllPage">查看全部</button>
            </div>
        </div>
        <!-- <Login2 v-if="showLogin" :courseId='courseId'></Login2> -->
        <Login3 v-if="showLogin" @getUserinfo="getUserinfo"></Login3>
    </div>
</template>

<script>
import Calendar from './calendar.vue';
import { EventBus } from './eventBus';
export default {
    components: {
        Calendar
    },
    data() {
        return {
            imgUrl: 'https://yun.cnuen.net/api/fu/front/upload/download?identifier=',
            loop: false,
            currentIndex: -1,
            videoAutoplay: true,
            autoplay: false,
            activeIndex: 0,
            menuList: [{
                label: '全部资讯',
                dictValue: undefined
            },
            {
                label: "通知公告",
                dictValue: undefined
            }, {
                label: "工作动态",
                dictValue: undefined
            },

            ],
            left: 10,
            options: {
                licenseKey: "OPEN-SOURCE-GPLV3-LICENSE",
                scrollOverflow: true,
                scrollBar: true,
                menu: "#menu",
                sectionsColor: [
                    "#fff",
                    "#fff",
                    "#f5f5f5",
                    "#fff",
                ],
                lazyLoading: true,
            },
            focusClazz: undefined,
            newsList: [],
            currenBannerNews: {},
            otherNewsList: [],
            valuesList: [{
                icon: require("../assets/home-page/value1.png"),
                name: '放大',
                desc: '以京蒙教育协作智慧平台为支撑，以点带面，扩大京蒙教育协作覆盖面，让每一个内蒙古师生都能从中受益，形成“大协作”格局。',
                backgroundImg: require("../assets/home-page/jihe1.png"),
            },
            {
                icon: require("../assets/home-page/value2.png"),
                name: '叠加',
                desc: '以京蒙教育协作为基础，融合驼铃行动、“双新”示范区、教育部国家级教育信息化实验区，释放教育改革活力，实现多种效益叠加。',
                backgroundImg: require("../assets/home-page/jihe2.png"),
            },
            {
                icon: require("../assets/home-page/value3.png"),
                name: '倍增',
                desc: '丰富资源供给，优化教育服务，推动交互共建共享，激发资源应用效能倍增，助力城乡教育优质均衡。',
                backgroundImg: require("../assets/home-page/jihe3.png"),
            }, {
                icon: require("../assets/home-page/value4.png"),
                name: '溢出',
                desc: '形成一批可复制可推广的特色模式、经验，进行宣传推广，辐射带动内蒙古更多区域发展。',
                backgroundImg: require("../assets/home-page/jihe4.png"),
            }
            ],
            developSubList: [{
                name: '教师队伍素养提升工程',
                icon: require("../assets/home-page/develope1.png")
            },
            {
                name: '创新拔尖人才培养工程',
                icon: require("../assets/home-page/develope2.png")
            },
            {
                name: '课堂教学数字化工程',
                icon: require("../assets/home-page/develope3.png")
            },
            {
                name: '教学评估督导智能化工程',
                icon: require("../assets/home-page/develope4.png")
            },
            {
                name: '民族团结和生态实践研学',
                icon: require("../assets/home-page/develope5.png")
            }
            ],
            statsList: [{
                num: 22,
                name: '名师工作室数量',
                icon: require("../assets/home-page/Bank.png"),
                backgroundColor: 'rgba(0,153, 43, .9)',
                bottom: '32%'
            },
            {
                num: 589,
                name: '名师数量',
                icon: require("../assets/home-page/Photos.png"),
                backgroundColor: 'rgba(25, 118, 197, .9)',
                bottom: '28%'
            },
            {
                num: 5809,
                name: '成果数量',
                icon: require("../assets/home-page/Badge.png"),
                backgroundColor: 'rgba(172, 24, 24, .9)',
                bottom: '28%'
            },
            {
                num: 35,
                name: '合作区域数量',
                icon: require("../assets/home-page/map.png"),
                backgroundColor: 'rgba(155, 24, 140, .9)',
                bottom: '34%'
            },
            {
                num: 375,
                name: '合作校数量',
                icon: require("../assets/home-page/Office.png"),
                backgroundColor: 'rgba(24, 83, 166, .9)',
                bottom: '33.9%'
            },
            {
                num: 7809,
                name: '服务教师数',
                icon: require("../assets/home-page/friends.png"),
                backgroundColor: 'rgba(242, 158, 24, .9)',
                bottom: '33.8%'
            },
            {
                num: 78009,
                name: '服务学生数',
                icon: require("../assets/home-page/student.png"),
                backgroundColor: 'rgba(25, 190, 237, .9)',
                bottom: '32%'
            }
            ],
            imgHeight: '100%',
            imgList: [],
            focusList: [{
                title: '枣庄市副市长张庆一行来校考察交流',
                introduction: '2月2日，枣庄市人民政府副市长张庆伟一行来校考察交流。我校党委书张庆伟一行来校考察交流。我张庆伟一行来校考察交流。我记孟繁华，党委常委、副校长李小娟出席座谈会，学校办公室、国际合作交流处.....',
                cover: require('../assets/home-page/attention.png'),
                logo: require('../assets/home-page/source.png'),
                createTime: '2023-02-02'
            }],
            schoolList: [{
                name: '北京十二中',
                img: require('../assets/images/school1.jpg')
            },
            {
                name: '陈经纶中学',
                img: require('../assets/images/school2.jpg')
            },
            {
                name: '大兴三中',
                img: require('../assets/images/school3.jpg')
            },
            {
                name: '北京市第一O一中学',
                img: require('../assets/images/school4.jpg')
            },
            {
                name: '兴安盟扎赉特旗音德尔第三中学',
                img: require('../assets/images/school5.png')
            },
            {
                name: '赤峰市巴林左旗林东第九中学',
                img: require('../assets/images/school6.png')
            },
            {
                name: '锡林郭勒盟正镶白旗第二中学',
                img: require('../assets/images/school7.png')
            },
            {
                name: '兴安盟科尔沁右翼中旗巴彦呼舒镇第三中学',
                img: require('../assets/images/school8.png')
            },
            ],
            courseList: [],
            courseId: null,
            showLogin: false,
        }
    },
    methods: {
        more() {
            window.open("https://dctest.lezhireading.com/#/jmcountry");
        },
        // banner图跳转
        jump(item) {
            if (item.indexOf('https://') != -1 || item.indexOf('http://') != -1) {
                window.open(item)
            } else {
                window.open(`https://${item}`)
            }

        },
        goDetail(event) {
            this.$router.push(`news/detail/${event.id}`)
        },
        goNewsList(event) {
            this.$router.push({
                path: '/home/news',
                query: {
                    clazz: event.dictValue
                }
            })
        },
        changeNews(index, oldIndex) {
            this.currenBannerNews = this.newsList[index];
        },
        goAllPage() {
            this.$router.push({
                path: '/home/news',
                query: {
                    clazz: this.focusClazz,
                }
            })
        },
        chooseMenu(menuIndex) {
            this.activeIndex = menuIndex;
            setTimeout(() => {
                this.lineChange()
                this.getNewsList(this.menuList[menuIndex].dictValue)
                this.getOtherNewsList(this.menuList[menuIndex].dictValue)
            }, 100)
        },
        lineChange() {
            let line = document.querySelector('.tabActive')
            let bottomLine = document.querySelector('.bottom_line')
            // console.log(line.offsetWidth);
            this.left = line.offsetLeft + (line.offsetWidth / 2 - (bottomLine.offsetWidth / 2));
        },
        handleClick(tab, event) {
            // console.log(tab, event);
        },
        imgLoad() {
            this.$nextTick(() => {
                this.imgHeight = `${document.documentElement.clientHeight}px`
            })
        },
        async getLabes() {
            let resData = await Api.Home.getLabes({
                dict: 'web_banner_column'
            })
        },
        async getBanners() {
            let resData = await Api.Home.getBanners({
                type: 1
            })
            // console.log('getBanners', resData);
            this.imgList = resData.data;
        },
        async getNewsLabes() {
            let resData = await Api.Home.getLabes({
                dict: 'website_news_type'
            })
            resData.data.map(item => {
                if (item.label == '媒体关注') {
                    this.focusClazz = item.dictValue
                }
                this.menuList.map(each => {
                    if (item.label == each.label) {
                        each.dictValue = item.dictValue;
                    }
                })
            })
            this.$store.commit('setNewsLabel', resData.data)
            this.getFocusNews();
            this.getNewsList(this.menuList[this.activeIndex].dictValue)
            this.getOtherNewsList(this.menuList[this.activeIndex].dictValue)
        },
        // 请求置顶新闻
        async getNewsList(type) {
            let that = this;
            let params = {
                clazz: type, //轮播图新闻
                isAsc: 'desc',
                pageNum: 1,
                pageSize: 3,
                sort: 1,
            }
            let resData = await Api.Home.getNews(params)
            // console.log('news', resData)
            this.newsList = resData.rows
            if (JSON.stringify(this.rows) == '[]') {
                this.currenBannerNews = null;
                return;
            };
            this.currenBannerNews = this.newsList[0];
        },
        // 请求非置顶新闻
        async getOtherNewsList(type) {
            let that = this;
            let params = {
                clazz: type, //轮播图新闻
                isAsc: 'desc',
                pageNum: 1,
                pageSize: 4,
                sort: 2,
            }
            let resData = await Api.Home.getNews(params)
            // console.log('otherNews', resData)
            this.otherNewsList = resData.rows
        },
        async getFocusNews() {
            let resData = await Api.Home.getNews({
                pageNum: 1,
                pageSize: 3,
                isAsc: 'desc',
                clazz: this.focusClazz
            })
            this.focusList = resData.rows
        },
        goBusiness(index) {
            window.open(`http://jm.cnueb.net/#/home/business?index=${index + 1}`)
        },
        carouselChange(val, val2) {
            // console.log(val);
            this.currentIndex = val;
            if (this.imgList[val].bannerType == '1') {
                // 暂停自动轮播,
                this.autoplay = false;
                const currentSlide = this.$refs.myVideo;
                currentSlide.play()
            } else {
                this.autoplay = true;
            }
        },
        playEnd() {
            this.autoplay = true;
            const currentSlide = this.$refs.myVideo;
            currentSlide.currentTime = 0;
        },
        // 优质课程
        GetSuperiorCourse() {
            let data = {
                projectId: -1
            }
            Api.Home.GetSuperiorCourse(data)
                .then(res => {
                    // console.log('优质课程:', res);
                    this.courseList = res.data
                })
                .catch(err => {
                    console.log('err:', err)
                })
        },
        defaultCover(e) {
            e.target.src = require("../assets/home/course.png")
        },
        goCourse(id) {
            console.log('课程id:', id)
            this.courseId = id;
            console.log('access_token:', sessionStorage.getItem('token'));
            if (!sessionStorage.getItem('token')) {
                this.showLogin = true;
                this.$store.commit('isDisplayLogin', true);
            } else {
                let access_token = sessionStorage.getItem('token');
                let member = sessionStorage.getItem('member')
                window.open(
                    `https://jm.cnuen.net/login?origin=cnueb&access_token=${access_token}&member=${member}&courseId=${this.courseId}&projectId=390&goPath=course`
                )
            }
        },
        getUserinfo() {
            EventBus.$emit('test', 'Hello from ComponentA')
        },
        // 跳转课程
        gocurriculumPublic() {
            this.$router.push({
                path: 'curriculumPublic',
                query: {
                    markType: 4,
                    'breadNumber': 2,
                }
            })
        },
        // 新版ca登录
        async newCALogin(){
            let data = {
                code:this.$route.query.code
            }
            let resData = await Api.Login.newcalogin(data);
            console.log('新版CA登录:',resData);
            if (resData.code === 200 && resData.data.access_token) {
                sessionStorage.setItem('token', resData.data.access_token);
                this.getUserinfo();
            } else if (!resData.data.bind) {
                this.$router.push({
                    path: "/upDateInfoCA",
                    query: {
                        userName: resData.data.user_name,
                        tempToken: resData.data.temp_token,
                    }
                })
            }
        }
    },
    mounted() {
        let line = document.querySelector('.tabActive')
        let bottomLine = document.querySelector('.bottom_line')
        this.left = line.offsetLeft + (line.offsetWidth / 2 - (bottomLine.offsetWidth / 2));

        window.onresize = () => {
            if (JSON.stringify(this.$refs.imgHeight) == '[]') return;
            // 通过点语法获取img的height属性值
            // this.imgHeight = `${this.$refs.imgHeight[0].height - 115}px`
            this.imgHeight = `${document.documentElement.clientHeight}px`
            // console.log('imgHeight', this.imgHeight);
            // console.log(document.getElementsByClassName('banner'))
            for (let index = 0; index < document.getElementsByClassName('banner').length; index++) {
                if (document.documentElement.clientHeight >= 1080) {
                    document.getElementsByClassName('banner')[index].style.height = '100%'
                } else {
                    document.getElementsByClassName('banner')[index].style.height = 'auto'
                }

            }
            // document.getElementsByTagName('video').play()
        }
        this.getNewsLabes();
        this.GetSuperiorCourse()

        if(this.$route.query.code){
            this.newCALogin()
        }
    },
}
</script>

<style lang="less" scoped>
@import url("./less/homePage.less");
</style>